import React, { useEffect } from "react";
import Typewriter from "typewriter-effect";
import { data } from "./ProjectArray";

import Aos from "aos";
import "aos/dist/aos.css";
const Projects = ({ color }) => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <div>
      <section
        className={color ? "projects section cbg" : "projects section"}
        id="projects"
      >
        <div
          className="section-title "
          data-aos="fade-in"
          data-aos-anchor-placement="top-bottom"
        >
          <h2> Projects </h2> <div className="underline"> </div>
          <p className="projects-text">
            <Typewriter
              options={{
                strings: [
                  "Here is some projects based on HTML/CSS, Nodejs, Java Script and React.",
                ],
                autoStart: true,
                loop: true,
                delay: 75,
              }}
            />{" "}
          </p>{" "}
          <div className="projects-center section-center">
            {" "}
            {data.map((project, index) => {
              const { name, img, description, link } = project;
              return (
                <a href={link}>
                  <article className="project" data-aos="fade-up">
                    <img src={img} alt="" className="project-img" />
                    <div className="project-info">
                      <h4> {name} </h4> <p> {description} </p>{" "}
                    </div>{" "}
                  </article>{" "}
                </a>
              );
            })}{" "}
          </div>{" "}
        </div>{" "}
      </section>{" "}
    </div>
  );
};

export default Projects;
